<!--
    Component Name: FamilyPhaseEditor
    Summary:
    Properties:
-->
<template>
    <div class="FamilyPhaseEditor">
        <div v-if="CheckPermission(ViewPermissionRequirement)">
            <b-row>
                <h3>Family Status History:</h3>
            </b-row>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              row-class="bold-first-row"
                              class="vue-datatable">
                        <template slot="Comments" scope="props">
                            <div class="CommentsDiv">
                                {{props.rowData.PhaseEntryNotes}}
                                <font-awesome-icon v-if="EditMode && CheckPermission(EditPermissionRequirement)" :icon="['fa', 'edit']" v-on:click="OpenEditComment(props.rowData)" class="pointer" />
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode && CheckPermission(EditPermissionRequirement)" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="pointer olive-green-text" />
                        </b-row>
                        <b-row v-if="TableState == 'OneOpen'">
                            <font-awesome-icon :icon="['fas', 'trash-alt']" v-on:click="ShowDeleteRecord()" class="pointer red" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <h3>Approval Activities:</h3>
            </b-row>
            <b-row>
                <div class="col col-md-4 col-sm-12">
                    <h4>Inquiry:</h4>
                    <p v-for="ai in ApprovalActivities.Inquiry">
                        <font-awesome-icon :icon="['fa', 'check']" class="olive-green-text" v-if="FamilyRecordData.Family[ai.PropertyName]" /> <span class="bold">{{ ai.PropertyLabel }}: </span>
                        <br />
                        <DateEditor v-bind:old-value="FamilyRecordData.Family[ai.PropertyName]"
                                    v-bind:record-id="FamilyRecordData.Family.Id"
                                    v-bind:edit-mode="EditMode"
                                    :data-label="ai.PropertyLabel"
                                    :property-name="ai.PropertyName"
                                    update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                    :required="false"
                                    null-string="Pending"
                                    :global-update="false"
                                    :dispatch-on-success="['update-family-list']" />
                    </p>

                </div>
                <div class="col col-md-4 col-sm-12">
                    <h4>Pre-Approval:</h4>
                    <p v-for="ai in ApprovalActivities.PreApproval">
                        <font-awesome-icon :icon="['fa', 'check']" class="olive-green-text" v-if="FamilyRecordData.Family[ai.PropertyName]" /> <span class="bold">{{ ai.PropertyLabel }}: </span>
                        <br />
                        <DateEditor v-bind:old-value="FamilyRecordData.Family[ai.PropertyName]"
                                    v-bind:record-id="FamilyRecordData.Family.Id"
                                    v-bind:edit-mode="EditMode"
                                    :data-label="ai.PropertyLabel"
                                    :property-name="ai.PropertyName"
                                    update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                    :required="false"
                                    null-string="Pending"
                                    :global-update="false"
                                    :dispatch-on-success="['update-family-list']" />
                    </p>
                </div>
                <div class="col col-md-4 col-sm-12">
                    <h4>Approval:</h4>
                    <p v-for="ai in ApprovalActivities.Approval">
                        <font-awesome-icon :icon="['fa', 'check']" class="olive-green-text" v-if="FamilyRecordData.Family[ai.PropertyName]" /> <span class="bold">{{ ai.PropertyLabel }}: </span>
                        <br />
                        <DateEditor v-bind:old-value="FamilyRecordData.Family[ai.PropertyName]"
                                    v-bind:record-id="FamilyRecordData.Family.Id"
                                    v-bind:edit-mode="EditMode"
                                    :data-label="ai.PropertyLabel"
                                    :property-name="ai.PropertyName"
                                    update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                    :required="false"
                                    null-string="Pending"
                                    :global-update="false"
                                    :dispatch-on-success="['update-family-list']" />

                    </p>
                </div>

            </b-row>


            <!--ADD NEW RECORD MODAL-->
            <b-modal ref="add-modal" title="Update Family Status" hide-footer>
                <b-container>
                    <b-form @submit="AddRecord">
                        <b-row>
                            <b-col>
                                <h4 class="bold underline">DEFINITIONS:</h4>
                                <p><span class="bold">Inquiry:</span> The start of the approval process.  All new families start with this status.</p>
                                <p><span class="bold">Application Started:</span> The application has been officially started.</p>
                                <p><span class="bold">Board Approval Pending:</span> Family application has been submitted to the Nation Board at the Home Office.</p>
                                <p><span class="bold">Pre-Approved:</span> Family has been given pre-approval status, and Home Study is being written.</p>
                                <p><span class="bold">County Clearance Pending:</span> Family is approved by regional office, and is currently awaiting a clearance by the County of record.</p>
                                <p><span class="bold">Approval On Hold:</span> Family can not move forward in the approval process due to pending conditions or other issues.</p>
                                <p><span class="bold">Closed:</span> Family has ended the approval process <span class="underline">before</span> reaching approval status.  This could be due to them choosing to drop out of the process, or Olive Crest making that decision.</p>

                                <p><span class="bold">Approved:</span> Official approved status, and family is able to accept placements.</p>
                                <p><span class="bold">Approved, Current Placement Hold:</span> Family reached approved status, however there is a current placement hold in effect on all new placements.</p>
                                <p><span class="bold">Approved, Suspended:</span> Approval status is officially suspended due to some process.  No current or future placements possible under this status.</p>
                                <p><span class="bold">Inactive:</span> Previously Approved, however is on a voluntary approval hold.  Possibility of moving back to Approved status within 2 years.  No Placements.</p>
                                <p><span class="bold">Approval Rescinded:</span> Previously Approved, but no longer approved and not on Inactive Status</p>
                                <div class="form-group">
                                    <label>New Status:</label>
                                    <select class="form-control" required v-model="FormData.PhaseName">
                                        <option selected value="" hidden></option>
                                        <option value="Inquiry">Inquiry</option>
                                        <option value="Application Started">Application Started</option>
                                        <option value="Board Approval Pending">Board Approval Pending</option>
                                        <option value="Pre-Approved">Pre-Approved</option>
                                        <option value="County Clearance Pending">County Clearance Pending</option>
                                        <option value="Approval On Hold">Approval On Hold</option>
                                        <option value="Closed">Closed</option>
                                        <option value="Approved">Approved</option>
                                        <option value="Approved, Current Placement Hold">Approved, Current Placement Hold</option>
                                        <option value="Approved, Suspended">Approved, Suspended</option>
                                        <option value="Inactive">Inactive</option>
                                        <option value="Approval Rescinded">Approval Rescinded</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Effective Date of Change:</label>
                                    <flat-pickr v-model="FormData.TransferDate" class="form-control" required :config="DateConfig"></flat-pickr>
                                </div>
                                <div class="form-group">
                                    <label>Reason For Status Change:</label>
                                    <select class="form-control subcategory-selectee status-change-reason" required autocomplete="off" v-model="FormData.PhaseEntryReason">
                                        <option value="" hidden selected></option>
                                        <!--@*Inquiry Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Church">Referral: Church</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: KFSH">Referral: KFSH</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: KWVE">Referral: KWVE</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Christian Examiner">Referral: Christian Examiner</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Christian Business Directory">Referral: Christian Business Directory</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Angels in Waiting">Referral: Angels in Waiting</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Olive Crest Foster Family">Referral: Olive Crest Foster Family</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Olive Crest Staff">Referral: Olive Crest Staff</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Special Event">Referral: Special Event</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: CA Kids Connection">Referral: CA Kids Connection</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: AdoptUSKids">Referral: AdoptUSKids</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: County Social Services">Referral: County Social Services</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Internet Search - Google">Referral: Internet Search - Google</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Internet Search - Bing">Referral: Internet Search - Bing</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Internet Search - Yahoo">Referral: Internet Search - Yahoo</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Internet Search - DuckDuckGo">Referral: Internet Search - DuckDuckGo</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Internet Search - Other">Referral: Internet Search - Other</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Olive Crest Newsletter or Facebook">Referral: Olive Crest Newsletter or Facebook</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Send Conference">Referral: Send Conference</option>
                                        <option v-if="FormData.PhaseName == 'Inquiry'" value="Referral: Other">Referral: Other (see notes)</option>
                                        <!--@*PreApproval Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Application Started'" value="Application process officially started with Family">Application process oficially started with Family</option>
                                        <!--@*PreApproval Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Pre-Approved'" value="Pre-Approval Granted By Olive Crest">Pre-Approval Granted By Olive Crest</option>
                                        <!--@*PreApproval On Hold Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Counseling">Counseling</option>
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Family Loss">Family Loss</option>
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Regional Requirements">Regional Requirements</option>
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Board Requirements">Board Requirements</option>
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Deployment">Deployment</option>
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Family Move">Family Move</option>
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Unexpected Pregnancy">Unexpected Pregnancy</option>
                                        <option v-if="FormData.PhaseName == 'Approval On Hold'" value="Appeal Process">Appeal Process</option>
                                        <!--@*Closed Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Violation of Law or Standard">Violation of Law or Standard</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Rejected Regional Requirements">Rejected Regional Requirements</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Rejected Board Requirements">Rejected Board Requirements</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Reported Unresolved Trauma">Reported Unresolved Trauma</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Exhibited Disruptive Behavior">Exhibited Disruptive Behavior</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Exhibited Poor or Irresponsible Behavior">Exhibited Poor or Irresponsible Behavior</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Undisclosed Arrest/Conviction">Undisclosed Arrest/Conviction</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Evidence of Poor Financial Stewardship">Evidence of Poor Financial Stewardship</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Undisclosed Allegation/Investigation">Undisclosed Allegation/Investigation</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Failure to Pass Background Check">Failure to Pass Background Check</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Unable to Secure Medical Release">Unable to Secure Medical Release</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Unable to Secure Therapeutic Release">Unable to Secure Therapeutic Release</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Poor Reference Feedback">Poor Reference Feedback</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="No Response from Family">No Response from Family</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Family Moved">Family Moved</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Poor Timing/Family Circumstances">Poor Timing/Family Circumstances</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Other: Family Decision">Other: Family Decision</option>
                                        <option v-if="FormData.PhaseName == 'Closed'" value="Other: Olive Crest Decision">Other: Olive Crest Decision</option>
                                        <!--@*Board Approval Pending Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Board Approval Pending'" value="Application submitted to board">Application submitted to board</option>
                                        <!--@*County Clearance Pending Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'County Clearance Pending'" value="Approval Granted, awaiting county clearance">Approval Granted, awaiting county clearance</option>
                                        <!--@*Approval Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Approved'" value="Approval Granted by Olive Crest and Family Cleared through County">Approval Granted by Olive Crest and Family Cleared through County</option>
                                        <!--@*Approved Current Placement Hold Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Approved, Current Placement Hold'" value="Pending Home Investigation">Pending Home Investigation</option>
                                        <!--@*Approved Suspended Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Approved, Suspended'" value="Pending Home Investigation">Pending Home Investigation</option>
                                        <!--@*Approved Inactive Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Inactive'" value="Family Needs Break">Family Needs Break</option>
                                        <option v-if="FormData.PhaseName == 'Inactive'" value="Illness">Illness</option>
                                        <!--@*Decertified Reasons*@-->
                                        <option v-if="FormData.PhaseName == 'Approval Rescinded'" value="Decision by CCL">Decision by CCL</option>
                                        <option v-if="FormData.PhaseName == 'Approval Rescinded'" value="Family Choice - Unspecified">Family Choice - Unspecified</option>
                                        <!--@*OTHER*@-->
                                        <option value="Other">Other (see notes)</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Status Change Notes (optional):</label>
                                    <textarea class="form-control" autocomplete="off" v-model="FormData.PhaseEntryNotes" rows="3"></textarea>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelAddRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>



            <!--DELETE CURRENT RECORD MODAL-->
            <b-modal ref="delete-modal" title="Remove Current Status" hide-footer>
                <b-container>
                    <b-form @submit="DeleteRecord">
                        <b-row>
                            <b-col>
                                <p>WARNING: You are about to delete this family's current status.  If the family family had a previous status, that status will become the active status.</p>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelDeleteRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="danger" type="submit">
                                    DELETE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
            <b-modal ref="OpenEditCommentModal" title="Edit Comment" hide-footer>
                <b-container>
                    <b-form @submit="UpdateComment">
                        <b-row style="margin-bottom:1rem;">
                            <b-col>
                                <b-form-textarea cols="3" v-model="FormData.PhaseEntryNotes"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="$refs['OpenEditCommentModal'].hide()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    SUBMIT
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </div>
        <div v-else>
            PRIVATE
        </div>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExchangeAlt);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);

    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import DateEditor from '../../../Core/ItemEditors/DateEditor';

    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        props: [
            "EditPermissionRequirement",
            "ViewPermissionRequirement",
            "RecordId",
            "TableData",
            "EditMode",
            "FamilyRecordData",
        ],
        data: function () {
            return {
                //FamilyRecordDataLocal: {},
                TableFields: [
                    {
                        name: 'Name',
                        title: 'Status'
                    },
                    {
                        name: 'PhaseEntryReason',
                        title: 'Reason'
                    },
                    {
                        name: '__slot:Comments',
                        title: 'Comments'
                    },
                    {
                        name: 'StartDate',
                        title: 'Start',
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: 'EndDate',
                        title: 'End',
                        callback: 'formatDate|MM/DD/YY|N/A'
                    },
                ],
                FormData: {
                    FosterResourceFamilyID: this.RecordId,
                    TransferDate: "",
                    PhaseEntryReason: "",
                    PhaseName: "",
                    PhaseEntryNotes: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'm/d/Y',
                    altInput: true, 
                    //required: true,
                    allowInput: true
                },
                ApprovalActivities: {
                    Inquiry: [
                        {
                            PropertyName: "APInitialContact",
                            PropertyLabel: "Initial Contact with Family"
                        },
                        {
                            PropertyName: "APInitialPhoneAppointment",
                            PropertyLabel: "Initial Phone Appointment"
                        },
                        {
                            PropertyName: "APInitialHomeVisit",
                            PropertyLabel: "Initial Home Visit"
                        }
                    ],
                    PreApproval: [
                        {
                            PropertyName: "APClinicalInterviewerAssigned",
                            PropertyLabel: "Clinical Interviewer Assigned"
                        },
                        {
                            PropertyName: "APClinicalInterviewerMetWithFamily",
                            PropertyLabel: "Clinical Interviewer Met with Family"
                        },
                        {
                            PropertyName: "APInOfficeScreening",
                            PropertyLabel: "In Office Screening"
                        },
                        {
                            PropertyName: "APReviewBoardSummarySubmitted",
                            PropertyLabel: "Review Board Summary Submitted"
                        },
                        {
                            PropertyName: "APPreApprovalPacketEmailedToFamily",
                            PropertyLabel: "Pre-Approval Packet Emailed to Family"
                        },
                        {
                            PropertyName: "APApprovalGuideDeliveredExplainedToFamily",
                            PropertyLabel: "Approval Guide Delivered & Explained to Family"
                        },
                        {
                            PropertyName: "APPreApprovalEmailedToFamily",
                            PropertyLabel: "Pre-Approval Email Sent to Family"
                        }
                    ],
                    Approval: [
                        {
                            PropertyName: "APPreApprovalDocumentsReceived",
                            PropertyLabel: "All Pre-Approval Documents Received"
                        },
                        {
                            PropertyName: "APHomeInspectionChecklistReceived",
                            PropertyLabel: "Home Inspection Checklist Received"
                        },
                        {
                            PropertyName: "APFinalHomeInspection",
                            PropertyLabel: "Final Home Inspection"
                        },
                        {
                            PropertyName: "APClinicalInterviewerInformedOfFinalInspectionOutcome",
                            PropertyLabel: "Clinical Interviewer Informed of Final Inspection Outcome"
                        },
                        {
                            PropertyName: "APHomeInspectionChecklistFinalized",
                            PropertyLabel: "Home Inspection Checklist Finalized"
                        },
                        {
                            PropertyName: "APFamilyInformedOfApproval",
                            PropertyLabel: "Family Informed of Approval"
                        },
                        {
                            PropertyName: "APApprovalCertificateSentToFamily",
                            PropertyLabel: "Approval Certificate Sent to Family"
                        }
                    ]
                }
            };
        },
        methods: {
            //ADD RECORD
            ShowAddRecord() {
                this.$set(this, 'FormData', {
                    FosterResourceFamilyID: this.RecordId,
                    TransferDate: "",
                    PhaseEntryReason: "",
                    PhaseName: "",
                    PhaseEntryNotes: ""
                });
                this.$refs['add-modal'].show();
                
            },
            ApprovalActivityChanged() {
                console.log("approval activity changed");
            },
            AddRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/ChangeFamilyPhase", this.FormData, this.AddRecordSuccess, () => { }, true);
            },
            AddRecordSuccess(response) {
                this.$refs['add-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate();
            },
            UpdateApprovalActivity(propName, eventOut) {
                //var vm = this;
                console.log(eventOut);
                let payload = {
                    Id: this.RecordId,
                    [propName]: this.FamilyRecordData.Family[propName]
                }
                console.log(this.FamilyRecordData.Family[propName]);
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/UpdateFamily", payload, () => { }, () => { }, false);

            },
            CancelAddRecord() {
                this.$refs['add-modal'].hide();
            },
            OpenEditComment(rowData) {
                this.FormData.PhaseEntryNotes = rowData.PhaseEntryNotes;
                this.$refs['OpenEditCommentModal'].show();
            },
            UpdateComment(e) {
                e.preventDefault();
                let vm = this;
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/UpdateFamilyPhaseEntryNotes",
                    {
                        Id: vm.RecordId,
                        String: vm.FormData.PhaseEntryNotes
                    }, this.UpdateCommentSuccess, () => { }, false);
            },
            UpdateCommentSuccess(response) {
                 this.$refs['OpenEditCommentModal'].hide();
                 EventBus.$emit('update-family-list', true);
            },
            //DELETE RECORD
            ShowDeleteRecord() {
                this.$refs['delete-modal'].show();
            },
            DeleteRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/RevokeCurrentPhase", {FosterResourceFamilyID: this.RecordId}, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.$refs['delete-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate();
            },
            CancelDeleteRecord() {
                this.$refs['delete-modal'].hide();
            },

            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate (value, fmt = 'D MMM YYYY', defaultValue='') {
              return (value == null)
                ? defaultValue
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            Vuetable,
            flatPickr,
            DateEditor
        },
        computed: {
            TableState: function () {
                if (this.TableData.length == 0) {
                    return "NoRecords";
                } else if (this.TableData.filter(datalist => datalist.EndDate == null).length == 0) {
                    return "AllClosed";
                } else {
                    return "OneOpen";
                }
            }
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr:first-child {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>